/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import Modal from 'react-modal';
import Iframe from 'react-iframe';
import PropTypes from 'prop-types';
import BookCoverImage from './BookDetailsComponents/BookCoverImage';
import Notes from './BookDetailsComponents/Notes';
import {TextInput, Select, RadioCheckGroup} from '@pearson-components/elements-sdk/build/dist.elements-sdk';
import {
    TRIM_SIZE,
    DEFAULT_PARENT_DISCIPLINE,
    PAGE_ORIENTATION,
    PORTRAIT_PAGE_ORIENTATION
} from '../../constants/constants';
import {PERMISSIONS} from '../../../constants/APP_CONSTANTS';
import UserPermissionSingleton from '../../../_helpers/UserPermissionSingleton';
import {FormattedMessage,intlShape} from 'react-intl';
import find from 'lodash/find';

const titleWithChapterWordAndChapterNumbers = 'TitleWithChapterWordAndChapterNumbers';
const titleWithOnlyChapterNumbers = 'TitleWithOnlyChapterNumbers';
const titleWithoutChapterNumbers = 'TitleWithoutChapterNumbers';

const CHAPTER_PREFIX = {
    TitleWithChapterWordAndChapterNumbers: <FormattedMessage id={'coverAndPrinting.TocPage.characterPrefixDropDown.v1'}/>,
    TitleWithOnlyChapterNumbers: <FormattedMessage id={'coverAndPrinting.TocPage.characterPrefixDropDown.v2'}/>,
    TitleWithoutChapterNumbers: <FormattedMessage id={'coverAndPrinting.TocPage.characterPrefixDropDown.v3'}/>,
    getLabel: function (value) {
        return this[value];
    }
};
import ModalDialog from "../../widgets/ModalDialog/ModalDialogLink";
import DigitalPriceModal from "./BookDetailsComponents/DigitalPriceModal";

export default class BookDetails extends Component {
    static get propTypes() {
        return {
            activeCollection: PropTypes.object,
            options: PropTypes.object,
            frontCoverImages: PropTypes.array,
            getFrontCoverImages: PropTypes.func,
            changeFrontCoverImage: PropTypes.func,
            getOverridePrice: PropTypes.func.isRequired,
            overridePrice: PropTypes.object,
            updateOverridePrice: PropTypes.func,
            match: PropTypes.object.isRequired,
            getBookDetailsInfo: PropTypes.func,
            etextStatuses: PropTypes.object.isRequired,
            vitalsourceStatuses: PropTypes.object.isRequired,
            bookBuildContent:PropTypes.object.isRequired,
            getFrontCoverPage: PropTypes.func,
            setComponent: PropTypes.func,
            updateTOCNumeration: PropTypes.func,
            getNotesWithHolds: PropTypes.func,
            saveNotesWithHolds: PropTypes.func,
            showOM3PAlert: PropTypes.func,
            closeModal: PropTypes.func
        };
    }
    static contextTypes = {
        intl: intlShape,
    }
    constructor (props) {
        super(props);
        this.discipline = {
            value: DEFAULT_PARENT_DISCIPLINE.id,
            label: DEFAULT_PARENT_DISCIPLINE.name
        };
        this.state = {
            chapterPrefixDropDown: null,
            selectedChapterPrefix: this.props.printTOCChapterType ? this.getCurrentChapterPrefix(this.props.printTOCChapterType) : '',
            title : this.props.activeCollection.title? this.props.activeCollection.title: '',
            accessCodeRequested: this.props.accessCodeRequested ? this.props.accessCodeRequested : false,
            forcedTrimSize: this.props.forcedTrimSize? this.props.forcedTrimSize : false,
            chapterHeaders: this.props.chapterHeaders? this.props.chapterHeaders : false,
            trimSize:  '',
            coverImageUrl: '',
            modalIsOpen :false,
        };
        this.getCurrentChapterPrefix = this.getCurrentChapterPrefix.bind(this);
        this.changeTocType = this.changeTocType.bind(this);
        this.generateChapterPrefixDropDown = this.generateChapterPrefixDropDown.bind(this);
        this.changeChapterPrefixDropDown = this.changeChapterPrefixDropDown.bind(this);
        this.updateTitleHandler = this.updateTitleHandler.bind(this);
        this.updateForcedTrimSizeHandler = this.updateForcedTrimSizeHandler.bind(this);
        this.updateChapterHeadersHandler = this.updateChapterHeadersHandler.bind(this);
        this.updateAccessCodeRequestHandler = this.updateAccessCodeRequestHandler.bind(this);
        this.updateTrimSizeHandler = this.updateTrimSizeHandler.bind(this);
        this.saveTitle = this.saveTitle.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeCoverImageModal = this.closeCoverImageModal.bind(this);
        this.cancelModal =this.cancelModal.bind(this);
    }

    generateChapterPrefixDropDown() {
        return [CHAPTER_PREFIX.getLabel(titleWithChapterWordAndChapterNumbers), CHAPTER_PREFIX.getLabel(titleWithOnlyChapterNumbers),CHAPTER_PREFIX.getLabel(titleWithoutChapterNumbers)];
    }

    getTrimSize(orientation){
        return orientation===PAGE_ORIENTATION.PORTRAIT ? ["6 x 9","10.5 x 12","8 x 10","9-5/8 x 12","9 x 10.875","8.5 x 11"] : ["10 x 8.5","11 x 9"];
    }

    getCurrentChapterPrefix(type){
        switch(type){
            case titleWithChapterWordAndChapterNumbers: return  "Chapter & Number";
            case titleWithOnlyChapterNumbers : return  "Number Only";
            case titleWithoutChapterNumbers : return  "None";
        }

    }
    updateTrimSizeHandler(e){
        this.props.guardDirtySetActive(true);
        this.props.updateTrimSize(e.currentTarget.value);
    }
    changeTocType(event){
        switch(event){
            case "Chapter & Number": this.props.updateTOCNumeration(titleWithChapterWordAndChapterNumbers);
                break;
            case "Number Only": this.props.updateTOCNumeration(titleWithOnlyChapterNumbers) ;
                break;
            case "None": this.props.updateTOCNumeration(titleWithoutChapterNumbers) ;
                break;
        }
    }

    componentDidMount () {
        if (typeof this.props.setComponent === 'function') {
            this.props.setComponent("BookDetails");
        }
        const collectionId = this.props.match.params.collId;
        this.props.getBookDetailsInfo(collectionId);
        this.props.getFrontCoverPage(collectionId);
    }
    componentWillMount() {
        this.setState({chapterPrefixDropDown: this.generateChapterPrefixDropDown() ,
        }, function () {
        });
        const collectionId = this.props.match.params.collId;
        this.props.getBookDetailsInfo(collectionId);
        this.props.getFrontCoverPage(collectionId);
        this.props.getNotesWithHolds(collectionId);
        this.props.showOM3PAlert(this.props.activeCollection.hasOMResources, this.props.activeCollection.has3PResources);
    }

    componentWillUnmount(){
        const collectionId = this.props.match.params.collId;
        this.props.getBookDetailsInfo(collectionId);
        this.props.hideOM3PAlert(this.props.activeCollection.hasOMResources, this.props.activeCollection.has3PResources);
    }

    changeChapterPrefixDropDown(event) {
        this.props.guardDirtySetActive(true);
        this.changeTocType(event.target.value);
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.printTOCChapterType !== nextProps.printTOCChapterType ){
            this.setState({ selectedChapterPrefix: this.getCurrentChapterPrefix(nextProps.printTOCChapterType) });
        }
        if(this.props.activeCollection.title !== nextProps.activeCollection.title){
            this.setState({
                title: nextProps.activeCollection.title
            });
        }
        if(this.props.forcedTrimSize !== nextProps.forcedTrimSize){
            this.setState({
                forcedTrimSize: nextProps.forcedTrimSize
            });
        }
        if(this.props.chapterHeaders !== nextProps.chapterHeaders){
            this.setState({
                chapterHeaders: nextProps.chapterHeaders
            });
        }
        if(this.props.accessCodeRequested !== nextProps.accessCodeRequested){
            this.setState({
                accessCodeRequested: nextProps.accessCodeRequested
            });
        }
        if(this.props.activeCollection.hasOMResources !== nextProps.activeCollection.hasOMResources
            && this.props.activeCollection.has3PResources !== nextProps.activeCollection.has3PResources){
            this.props.showOM3PAlert(nextProps.activeCollection.hasOMResources, nextProps.activeCollection.has3PResources);
        }
    }

    updateTitleHandler(evt){
        this.setState({
            title: evt.currentTarget.value
        });
        this.props.guardDirtySetActive(true);
    }

    saveTitle(){
        this.props.updateCollectionTitle(this.state.title);
    }

    updateForcedTrimSizeHandler(event){
        event.preventDefault();
        this.props.guardDirtySetActive(true);
        this.setState({
            forcedTrimSize:  event.currentTarget.checked
        });
        this.props.updateForcedTrimSize(event.currentTarget.checked);
    }

    updateChapterHeadersHandler(event){
        event.preventDefault();
        this.props.guardDirtySetActive(true);
        this.setState({
            chapterHeaders:  event.currentTarget.checked
        });
        this.props.updateChapterHeaders(event.currentTarget.checked);
    }
    updateAccessCodeRequestHandler(event){
        event.preventDefault();
        this.props.guardDirtySetActive(true);
        this.setState({
            accessCodeRequested:  event.currentTarget.checked
        });
        this.props.updateAccessCode(event.currentTarget.checked);
    }

    getUSPrice = () =>{
        let usPriceGeo = find(this.props.activeCollection.priceModel.priceGeos, val => val.priceGroup.name === "US Pricing");
        return '$'+usPriceGeo.totalPrice.toFixed(2);
    }
    openModal() {
        this.setState({modalIsOpen: true});
    }
    closeCoverImageModal() {
        const collectionId = this.props.match.params.collId;
        this.setState({modalIsOpen: false});
        this.props.getFrontCoverPage(collectionId);
    }
    cancelModal(){
        this.setState({modalIsOpen: false}); 
    }

    render() {
        const isCollectionReady = this.props.activeCollection !== {};  
        const {etextStatuses, vitalsourceStatuses} = this.props;
        return (
            isCollectionReady && <div className="book-details-page">
                <div className="notes">
                    <Notes activeCollection = {this.props.activeCollection} holds={this.props.collectionNotes.holds}
                        notes = {this.props.collectionNotes.collectionNoteDTOS} saveNotes = {this.props.saveNotesWithHolds}
                    />
                </div>

                <h6>Book Details</h6>

                <div className="title-group">
                    <div className="title">
                        <label className="pe-textLabelInput__label" htmlFor="title">Collection Title</label>
                        <input type="text" className="pe-textInput--basic" id="title" onBlur={this.saveTitle} onChange={this.updateTitleHandler}
                            value={this.state.title}  disabled={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_collection_title)}/>
                    </div>
                    <div className="title-message">
                        <label htmlFor="title-message-1" className="pe-textLabelInput__label">This Collection Title is
                            the title in Collections</label>
                        <label htmlFor="title-message-2" className="pe-textLabelInput__label">The Course Title is the
                            more prominent title in Console</label>
                        {/*
                        <span>This Collection Title is the title in Collections</span>
                        <span>The Course Title is the more prominent title in Console</span>
                        */}
                    </div>
                </div>

                <div className="pe-form--group toc">
                    { this.state.selectedChapterPrefix !== '' && <Select id="toc"
                        labelText="TOC Numeration"
                        changeHandler={this.changeChapterPrefixDropDown}
                        selectedOption = {this.state.selectedChapterPrefix}
                        options={["Select", "Chapter & Number", "Number Only", "None"]}
                        inputState={ UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_toc_numeration) ? "disabled" : ""}
                    />}
                </div>
                <div className="forced-trim">
                    <label htmlFor="forced-trim">
                        <input className=""  disabled ={ UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_forced_trim_size)} key={this.state.forcedTrimSize + "forced-trim-checkbox"}  type="checkbox" id="forced-trim" checked={this.state.forcedTrimSize} onChange={this.updateForcedTrimSizeHandler} /> Forced trim size
                    </label>
                </div>
                <div className="page-numbering">
                    <label htmlFor="page-numbering">
                        <input type="checkbox"  disabled ={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_automatic_page_numbering)} id="page-numbering" checked={this.props.automaticPageNumbering?this.props.automaticPageNumbering: false} /> Automatic page numbering
                    </label>
                </div>
                <div className="automated-indexes">
                    <label htmlFor="automated-indexes">
                        <input type="checkbox"  disabled ={ UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_automatic_indexes)} id="automated-indexes" checked={this.proautomaticIndexes? this.props.automaticIndexes : false}/> Automated indexes
                    </label>
                </div>
                <div className="chapter-headers">
                    <label htmlFor="chapter-headers">
                        <input type="checkbox" disabled ={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_chapter_headers)}  key={this.state.chapterHeaders + "chapter-headers"} id="chapter-headers" checked={this.state.chapterHeaders} onChange={this.updateChapterHeadersHandler} /> Chapter headers
                    </label>
                </div>
                <div className="forced-recto">
                    <label htmlFor="forced-recto">
                        <input type="checkbox"  disabled ={ UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_forced_recto_start)} id="forced-recto" checked={this.props.forcedRectoStart?this.props.forcedRectoStart:false}/> Forced-Recto Start
                    </label>
                </div>
                <div className="access-code">
                    <label htmlFor="access-code">
                        <input type="checkbox" disabled ={UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_instructor_has_requested_access_codes)} key={this.state.accessCodeRequested + "chapter-headers"}  id="access-code" checked={this.state.accessCodeRequested} onChange={this.updateAccessCodeRequestHandler}/> Instructor has
                        requested Access Codes
                    </label>
                </div>
                <div className="pages">
                    <label>Total book pages </label><span className="no-of-pages">{this.props.pageCount}</span>
                </div>
                <div className="price">
                    <div>
                        <div className="price-label">
                            <label>Digital Book ({this.props.activeCollection.geo && this.props.activeCollection.geo.code === "US"? "US": "Canada"} Pricing)</label>
                        </div>
                        <div className="price-detail">
                            { !UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_pricing) ? <ModalDialog
                                trigger={<a href="#">${this.props.activeCollection.priceModel ?
                                    (this.props.activeCollection.priceModel.totalPrice).toFixed(2) : '--'} </a>}
                                title="Digital Price"
                            >
                                <DigitalPriceModal activeCollection={this.props.activeCollection}
                                    getOverridePrice={this.props.getOverridePrice}
                                    updateOverridePrice={this.props.updateOverridePrice}
                                    getCollectionFromId={this.props.getCollectionFromId}
                                    collectionId={this.props.match.params.collId}
                                    closeModal={this.props.closeModal}
                                />
                            </ModalDialog> :<div className="price-label" >
                                <span>${this.props.activeCollection.priceModel ?
                                    (this.props.activeCollection.priceModel.totalPrice).toFixed(2) : '--'}</span> 
                            </div>}
                        </div>
                        {
                            (this.props.activeCollection && this.props.activeCollection.priceModel && this.props.activeCollection.priceModel.priceAdminUpdate && this.props.activeCollection.priceModel.priceAdminUpdate.specialPrice > 0) && <div className="price-message">
                                <label htmlFor="price-message" className="pe-textLabelInput__label price-message">*Special pricing
                                applied </label>
                            </div>
                        }
                    </div>
                    {
                        this.props.activeCollection.geo && this.props.activeCollection.geo.code === "CA" && this.props.activeCollection.priceModel && this.props.activeCollection.priceModel.priceGeos &&  <div style={{marginTop:'10px'}}>
                            <div className="price-label">
                                <label>Digital Book (US Pricing)</label>
                            </div>
                            <div className="price-detail">
                                <label>{this.getUSPrice()}</label>
                                
                            </div>
                            {
                                (this.props.activeCollection && this.props.activeCollection.priceModel && this.props.activeCollection.priceModel.priceAdminUpdate && this.props.activeCollection.priceModel.priceAdminUpdate.specialPrice > 0) && <div className="price-message">
                                    <label htmlFor="price-message" className="pe-textLabelInput__label price-message">*Special pricing
                                        applied </label>
                                </div>
                            }
                        </div>
                    }
                </div>
                <div className="pe-form--group trim-size">{
                    this.props.activeCollection.trimSize && <Select id="trimSize"
                        labelText="Trim Size"
                        selectedOption= {this.props.activeCollection.trimSize.name}
                        changeHandler={this.updateTrimSizeHandler}
                        options={this.getTrimSize( this.props.activeCollection.trimSize.orientation)}
                        inputState={ UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_trim_size) ? "disabled" : ""}
                    />
                }
                </div>
                <div className="cover-design">
                    <h5>Cover Design</h5>
                    {UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_cover_design) 
                         || (etextStatuses['PRODUCT_CREATION'].indexOf("SUCCESS") > -1)
                         || (etextStatuses['INITIAL_CONTENT_PROCESSING'].indexOf("SUCCESS") > -1) 
                         || (vitalsourceStatuses['VITALSOURCE_BOOK_INITIALIZED'].indexOf("SUCCESS") > -1) ?
                        "" : <span>Click to edit cover page</span>}                 
                    {
                        (this.props.bookBuildContent.productDeliveryType === 'custometext') ?
                            <label htmlFor="cover-message" className="pe-textLabelInput__label--label_focus cover-message">This
                            image will display to Students and Instructors in Pearson Etext</label> :

                            <label htmlFor="cover-message" className="pe-textLabelInput__label--label_focus cover-message">This
                                 image will display to Students and Instructors in Pearson Vitalsource</label>
                    }
                    <Modal

                        isOpen={this.state.modalIsOpen}
                        className="modal-content-cover"
                        overlayClassName="modal-overlay-cover"
                        onRequestClose={this.cancelModal}
                        contentLabel="coverPage"
                        closeTimeoutMS={150}
                    >
                        <div><div className="cover-page-modal-body">
                            <Iframe url={this.props.frontCoverurl}
                                width="105%" id="myId"
                                className="myClassname" display="initial" position="relative" height= "550px"/>
                        </div></div>
                        <div className="modal-footer-cover">
                            <button className="pe-btn--btn_large btn-cancel" onClick={this.cancelModal}>Cancel</button>
                            <button className='pe-btn__primary--btn_large btn-action' onClick={this.closeCoverImageModal}>Done</button>
                        </div>
                    </Modal>
                   
                    
                    <BookCoverImage collectionId={this.props.activeCollection.collectionId}
                        currentBookCoverUrl={ this.props.thumbnailUrl}
                        openModal={this.openModal}
                        hideModalVisibility = {(etextStatuses['PRODUCT_CREATION'].indexOf("SUCCESS") > -1) 
                        || (etextStatuses['INITIAL_CONTENT_PROCESSING'].indexOf("SUCCESS") > -1) 
                        || (vitalsourceStatuses['VITALSOURCE_BOOK_INITIALIZED'].indexOf("SUCCESS") > -1)
                        || (UserPermissionSingleton.hasPermission(PERMISSIONS.view_only_cover_design))}/>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetails.js